import { UtilityService } from './index'

class MeetingNotesServices {

    async listMeetingNotes(activePage) {
        
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/MeetingNotes', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page : activePage
            })
        })
        return {
            status : result.status,
            text : await result.json()
        }
    }

    async createMeetingNote(meetingNote){
        
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/addMeetingNotes', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(meetingNote)
        });
        return {
            text : await result.json(),
            status : result.status
        };
    }
   
    async cloneMeeting(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/cloneMN', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    
    async getMeetingNote(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/viewMeetingNote', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return { 
            text : await result.json(),
            status : result.status
        };
    }

    async removeMeeting(id){
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/MeetingNote', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text  : await result.json(),
            status : result.status,
        };
    }

    
    async searchMeetingNotesBy(by,value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/searchMeetingNotes', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by
            })
        });
        return {
            status : result.status,
            text : await result.json()
            };
    }


    //search and select meetingid
    async searchAndSelectMeetingId(by,value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/listSearchMN', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: value,
                by: by
            })
        });
        return {
            status : result.status,
            text : await result.json()
            };
    }

    
    async getGarmentInfo(by, value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/Systemstyles', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: "STYLE",
                subHeading: "GARMENTTYPE"
            })
        });
        return { 
            status : result.status,
            text : await result.json()
        };
    }
    
    async saveSketch(sketch) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/saveSketch', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                // 'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(sketch)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    
    async uploadNewImage(image) {
        var formData = new FormData();
        formData.append("referenceImages",image);        
        let result = await fetch(UtilityService.baseUrl() + 'api/style/uploadImagesSketch', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                // 'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return result.json();
    }

    
    async removeSketch(MNId, sketchId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/deleteSketch', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                sketchId: sketchId,
                meetingNoteId: MNId
            })
        });
        return result.json();
    }

    async getSystemMeetingNote() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/MeetingNotes', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        })
        return {
            status : result.status,
            text : await result.json()
        }
    }

    async getMeetingIDAndBarcode() {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/meetingNotesQR', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        })
        return {
            status : result.status,
            text : await result.json()
        }
    }

   
}
export default new MeetingNotesServices();


// WEBPACK FOOTER //
// ./src/services/meetingNotes.service.js